module.exports = __webpack_public_path__ + "img/camp.bd108a8.png";